import { ServiceDefinition } from './service-definition';

export class PermissionsServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri: string = 'portal-services/user/permissions';
    version: string = 'v1';

    family: string = 'netx360';
    appName: string = 'portal-svc';
    serviceName: string = 'app';
    mnemonic: string = 'nxp';

    static getInstance(): ServiceDefinition {
        if (!PermissionsServiceDefinition.instance) {
            PermissionsServiceDefinition.instance = new PermissionsServiceDefinition();
        }
        return PermissionsServiceDefinition.instance;
    }
    private constructor() {}
}
